export default __webpack_public_path__ + "static/media/crown.da0fd962.png";